import { memo, useState } from "react";
import IconButton from "../IconButton/IconButton";
import styles from "./hintBox.css";

/**
 * HintBox is a React functional component that displays a box with a header and text.
 * It includes a close button to hide the box, and remembers the hidden state using sessionStorage.
 *
 * @param {Object} props - The input properties for the component.
 * @param {string} props.header - The header text to display in the hint box.
 * @param {string} props.text - The main text content to display in the hint box.
 *
 * @returns {JSX.Element} The rendered hint box component.
 */
const HintBox = memo(({ header, text }) => {
  const [displayNone, setDisplayNone] = useState(
    sessionStorage.getItem("hideAnyHintBox") === "true",
  );

  function handleClick() {
    setDisplayNone(true);
    sessionStorage.setItem("hideAnyHintBox", "true");
  }

  return (
    <div className={styles.container({ hidden: displayNone })}>
      <div className={styles.topDiv}>
        <h2 className={styles.header}>{header}</h2>
        <IconButton name="xmark" onClick={handleClick} />
      </div>
      <p>{text}</p>
    </div>
  );
});

export default HintBox;
